import { z } from "zod";

export type ILifeatworkIntegrationSettings = z.infer<typeof TLifeatworkIntegrationSettings>;
export const TLifeatworkIntegrationSettings = z.object({
  client_id: z.string().optional(),
  client_secret: z.string().optional(),
  portalID: z.string().optional(),
  portalIDs: z.record(z.array(z.string())).optional(),
});
